import { useTenant } from '@state/useTenant';
import { useFreshness } from '@state/useFreshness';

/**
 * Footer — editorial mono-uppercase strip.
 *
 * Pattern:
 *   [AHP · Portal v2.1.1 · Reporting v4 · Build N] · [Snapshot YYYY-MM-DD] · [Cache-Control: no-store]
 */
export function Footer() {
  const tenant = useTenant();
  const { data: freshness } = useFreshness();
  const tShort =
    tenant.tenantId === 'alignment' ? 'AHP' : tenant.tenantId === 'claridyne' ? 'CHP' : 'CDX';
  const snapshotDate = freshness?.kind === 'fresh' ? freshness.snapshotDate : '—';

  return (
    <footer className="editorial-footer" role="contentinfo">
      <span>
        {tShort} · Portal v2.1.1 · Reporting v4 · Build 7c4f1e
      </span>
      <span>·</span>
      <span>
        Snapshot{' '}
        <span data-test-id="snapshot-date" style={{ fontVariantNumeric: 'tabular-nums' }}>
          {snapshotDate}
        </span>
      </span>
      <span style={{ marginLeft: 'auto' }}>Cache-Control: no-store</span>
    </footer>
  );
}
